import React from 'react';
import { FormikProps, withFormik } from 'formik';

import { Admin, adminFactory } from '@/types/admin';
import { adminSchema } from '@/services/validators/admin';
import { FormContents, Values } from './FormContents';

type OuterProps = {
  adminId: number;
  token?: string;
  isDisable: boolean;
  onSubmit: (admin: Admin, password: string, token: string) => void;
};

export const Activation = withFormik<OuterProps, Values>({
  mapPropsToValues: () => ({
    firstName: '',
    lastName: '',
    kanaFirstName: '',
    kanaLastName: '',
    password: '',
  }),
  validationSchema: adminSchema,
  handleSubmit: (values, { props, setSubmitting }) => {
    const admin = adminFactory({
      id: props.adminId,
      firstName: values.firstName,
      lastName: values.lastName,
      kanaFirstName: values.kanaFirstName,
      kanaLastName: values.kanaLastName,
    });
    props.onSubmit(admin, values.password, props.token || '');
    setSubmitting(false);
  },
})(
  // enhanced form
  ({
    errors,
    handleChange,
    handleSubmit,
    dirty,
    isSubmitting,
    isDisable = false,
    touched,
    values,
  }: OuterProps & FormikProps<Values>) => {
    return (
      <FormContents
        errors={errors}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        dirty={dirty}
        isSubmitting={isSubmitting}
        isDisable={isDisable}
        touched={touched}
        values={values}
      />
    );
  },
);
